<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_generate_token'">
                </div>
                <hr class="dialog-hr">
                <div class="confirm-body">
                    <div v-if="tokenCreated">
                        <span v-if="complexPassword" v-t="'message.info_generate_token_complete1'">
                        </span>
                        <span v-else v-t="{ path: 'message.info_generate_token_complete2', args: { user: loginName } }">
                        </span>
                        <br><br>
                        <span style="word-wrap: break-word" v-t="{ path: 'message.info_generate_token', args: { token: token } }">
                        <br><br>
                    </div>
                    <div v-else>
                        <span v-html="$t('message.desc_generate_token1', { userName: userAttribute.name })"></span><br><br>
                        <span style="color: #d55169" v-t="'message.desc_generate_token2'"></span><br><br>
                        <el-checkbox v-model="complexPassword">
                            <span v-t="'message.item_generate_newPassword'"></span>
                            <span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_generate_token_with_newPassword')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </span>
                        </el-checkbox>
                        <br><br>
                        <span v-t="'message.info_confirm_action'"></span><br>
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <div v-if="tokenCreated">
                        <el-button class="dialog-ok-button" @click="$emit('cancel')" v-t="'message.button_close'"></el-button>
                    </div>
                    <div v-else>
                        <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" @click="createToken" v-t="'message.button_generate'"></el-button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data() {
        return {
            complexPassword: false,
            tokenCreated: false,
            token: null,
            loginName: null
        };
    },
    methods: {
        createToken() {
            let self = this;
            server.post(
                '/createtoken',
                {
                    id: this.userAttribute.id,
                    complexPassword: this.complexPassword
                }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.tokenCreated = true;
                        self.token = res.data.token;
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_generate_token_denied") );
                        self.$emit('cancel');
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","createToken").replace("{code}",res.data.status));
                        self.$emit('cancel');
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "addGroup", error);
            });
        },
    },
    created: function() {
        this.loginName = this.userAttribute.name + "@" + this.appData.loginId.split("@")[1]
    },
    props: [ 'appData' , 'userAttribute']
}
</script scoped>
<style>
</style>
<style scoped>
.confirm-body >>> .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #5171cb;
    border-color: #5171cb;
}
.confirm-body >>> .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #5171cb;
}
</style>
